module.exports = __webpack_public_path__ + "img/image01.deb74f5f.jpg";